export default "__VITE_ASSET__DCjh9AYt__"